import { Message } from 'types/Message';
import { Grid } from '@mui/material';
import { formatDate, getFormattedEmailLabel } from '../AdminMessagesTableRow';
import { AdminMessagesTableDataTypeEnum } from '../AdminMessagesTableData';
import SelectMessageCheckbox from '../SelectMessageCheckbox';
import MessageBodyPreviewLoader from '../MessageBodyPreviewLoader';
import useStyles from './AdminMessagesMobileTableRow.styles';
import {Paperclip} from 'components/icons';

type AdminMessagesMobileTableRowProps = {
  message: Message;
  type: AdminMessagesTableDataTypeEnum;
  handleRowClick: (message: Message) => void;
};

const AdminMessagesMobileTableRow = ({ message, type, handleRowClick }: AdminMessagesMobileTableRowProps): JSX.Element => {
  const classes = useStyles();

  const handleClick = () => handleRowClick(message);

  return (
    <Grid alignItems="center" className={classes.container} container>
      <Grid item xs={2} />
      <Grid
        className={classes.email}
        item
        xs={8}
        onClick={handleClick}
      >
        {getFormattedEmailLabel(message, type)}
      </Grid>
      <Grid
        className={classes.attachment}
        item
        xs={2}
        onClick={handleClick}
      >
        {message.hasAttachment && <Paperclip fontSize='small' />}
      </Grid>

      <Grid item xs={2}>
        <SelectMessageCheckbox message={message} />
      </Grid>
      <Grid item xs={7} onClick={handleClick}>
        {message.subject}
      </Grid>
      <Grid
        className={classes.date}
        item
        xs={3}
        onClick={handleClick}
      >
        {formatDate(message.date)}
      </Grid>

      <Grid item xs={2} />
      <Grid
        className={classes.message}
        item
        xs={10}
        onClick={handleClick}
      >
        <MessageBodyPreviewLoader message={message} />
      </Grid>
    </Grid>
  );
};

export default AdminMessagesMobileTableRow;
